import React, { useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useHistory } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import TextFieldEditor from '../common/TextFieldEditor'
import Button from 'app/components/ButtonDefault'
import Text from 'app/components/Text'
import EditImageBlock from '../common/EditImageBlock'
import { promoPageSettingsImageInputProps } from 'app/constants/imageInputs'

import SignUpForm from '../../signUpForm/'

import './styles.scss'

const ShowOrHide = ({ hide, children }) => {
  if (hide) {
    return null
  }
  return children
}

const bc = 'promo-page-small'

const SmallVariant = ({
  image,
  title,
  subTitle,
  formTitle,
  formSubTitle,
  isPageEdit,
  handleSubmit,
  titleInputValue,
  subTitleInputValue,
  formTitleInputValue,
  change,
  formSubTitleInputValue,
  imageInputValue,
  pristine,
  submitting,
  valid,
  logo,
  t,
}) => {
  const history = useHistory()

  const [titleInputInitial, setTitleInputInitial] = useState(title)
  const [hideTitle, setHideTitle] = useState(false)

  const [subTitleInputInitial, setSubTitleInputInitial] = useState(subTitle)
  const [hideSubTitle, setHideSubTitle] = useState(false)

  const [formTitleInputInitial, setFormTitleInputInitial] = useState(formTitle)
  const [hideFormTitle, setHideFormTitle] = useState(false)

  const [formSubTitleInputInitial, setFormSubTitleInputInitial] = useState(formSubTitle)
  const [hideFormSubTitle, setHideFormSubTitle] = useState(false)

  const someTextFieldIsOpen = [hideTitle, hideSubTitle, hideFormTitle, hideFormSubTitle].includes(true)

  return (
    <div className={bc} style={{ backgroundImage: isMobile ? '' : `url(${imageInputValue || image})` }}>
      <EditImageBlock
        isPageEdit={isPageEdit}
        imageInputProps={promoPageSettingsImageInputProps}
        className={`${bc}__image-upload`}
        fieldWrapperClass={`${bc}__image-upload-input-wrap`}
        name="image"
      />

      <section className={`${bc}__left`}>
        <div className={`${bc}__text-content`} style={{ backgroundImage: isMobile ? `url(${image})` : '' }}>
          <div className={`${bc}__logo-wrapper`}>
            <img src={logo} alt="" />
          </div>

          <TextFieldEditor
            isPageEdit={isPageEdit}
            className={`${bc}__title-icon`}
            editorClassName={`${bc}__editor`}
            hideElement={setHideTitle}
            name="title"
            maxCharacters={42}
            onCancel={() => {
              change('title', titleInputInitial)
            }}
            onConfirm={() => {
              setTitleInputInitial(titleInputValue)
            }}
          />

          <ShowOrHide hide={hideTitle}>
            <Text htmlTag="h1" customWrapperClass={`${bc}__header`}>
              {titleInputInitial}
            </Text>
          </ShowOrHide>

          <TextFieldEditor
            isPageEdit={isPageEdit}
            className={`${bc}__title-icon`}
            editorClassName={`${bc}__editor`}
            hideElement={setHideSubTitle}
            name="subTitle"
            maxCharacters={620}
            onCancel={() => {
              change('subTitle', subTitleInputInitial)
            }}
            onConfirm={() => {
              setSubTitleInputInitial(subTitleInputValue)
            }}
          />

          <ShowOrHide hide={hideSubTitle}>
            <Text customWrapperClass={`${bc}__subtitle`}>{subTitleInputInitial} </Text>
          </ShowOrHide>
        </div>
      </section>

      <section className={`${bc}__right`}>
        <div className={`${bc}__form-wrapper`}>
          {isPageEdit && (
            <div className={`${bc}__form-fake-headers`}>
              <div className={`${bc}__form-title-wrapper`}>
                <TextFieldEditor
                  isPageEdit={isPageEdit}
                  className={`${bc}__form-title-icon`}
                  hideElement={setHideFormTitle}
                  maxCharacters={50}
                  name="formTitle"
                  onCancel={() => {
                    change('formTitle', formTitleInputInitial)
                  }}
                  onConfirm={() => {
                    setFormTitleInputInitial(formTitleInputValue)
                  }}
                />

                <ShowOrHide hide={hideFormTitle}>
                  <span className={`${bc}__title-form`}>{formTitleInputInitial}</span>
                </ShowOrHide>
              </div>

              <div className={`${bc}__form-sub-title-wrapper`}>
                <TextFieldEditor
                  isPageEdit={isPageEdit}
                  className={`${bc}__form-sub-title-icon`}
                  hideElement={setHideFormSubTitle}
                  maxCharacters={64}
                  name="formSubTitle"
                  onCancel={() => {
                    change('formSubTitle', formSubTitleInputInitial)
                  }}
                  onConfirm={() => {
                    setFormSubTitleInputInitial(formSubTitleInputValue)
                  }}
                />

                <ShowOrHide hide={hideFormSubTitle}>
                  <p className={`${bc}__subtitle-form`}>{formSubTitleInputInitial}</p>
                </ShowOrHide>
              </div>
            </div>
          )}

          <SignUpForm
            isPageEdit={isPageEdit}
            customClassName={`${bc}__form-wrapper`}
            formTitle={isPageEdit ? formTitleInputInitial : formTitle}
            formSubTitle={formSubTitle}
          />
        </div>
      </section>

      <div className={`${bc}__prohabits-block`}>
        <div>
          <img src="https://assets.prohabits.com/constants/ph-logo-gradient.png" alt="company logo" />
        </div>
        <Text customWrapperClass={`${bc}__copyright`}> © 2021 ProHabits, Inc.</Text>
      </div>

      <ShowOrHide hide={!isPageEdit}>
        <div className={`${bc}__buttons-block`}>
          <Button onClick={history.goBack}> {t('Go back')} </Button>

          <Button onClick={handleSubmit} disabled={pristine || submitting || !valid || someTextFieldIsOpen}>
            {t('Save changes')}
          </Button>
        </div>
      </ShowOrHide>
    </div>
  )
}

export default withTranslation('admin')(SmallVariant)
